export const getSelectedPromotionItem = (
  promotion: string,
  allSelectablePromotions: any[],
  type: string,
  index?: number
) => {
  const promotionId = promotion?.split(`#${index}#${type}`)?.[0];

  if (!promotionId) return;

  const promotions = allSelectablePromotions?.find(
    (item) => item?.type === type
  );

  if (!promotions) return;

  const selectedPromotionItem = promotions.promotions?.find(
    (promotion) => promotion.id === promotionId
  );

  return selectedPromotionItem ?? null;
};
